export function useMoney() {
  const config = useRuntimeConfig()

  function formatPrice(value: number) {
    return new Intl.NumberFormat('pl-PL', {
      style: 'currency',
      currency: config.public.currency ?? 'PLN',
      minimumFractionDigits: 2,
    }).format(value)
  }

  return { formatPrice }
}
